import React from 'react';
import { APP_CONFIG } from '../../../../configs/config';

/**
 * InsufficientCreditsModal Component
 * 
 * Displays a modal when user has insufficient credits to perform 
 * business card operations. Provides a link to top up credits.
 * 
 * @param {Object} props - Component props
 * @param {number} props.balance - Current credit balance
 * @param {Function} props.onClose - Callback when modal is closed
 * @returns {JSX.Element} - Modal component
 */
export default function InsufficientCreditsModal({ balance, onClose }) {
  const handleTopUp = () => {
    const returnUrl = encodeURIComponent(window.location.href);
    window.location.href = 
      `${APP_CONFIG.MAIN_WEBSITE_ORIGIN}/topup?returnUrl=${returnUrl}`;
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-gradient-to-br from-gray-800 to-red-900 rounded-3xl p-8 max-w-md w-full shadow-2xl border border-white/10">
        <h2 className="text-2xl font-bold text-yellow-400 mb-4 text-center">
          Insufficient Credits
        </h2>
        <p className="text-white/90 text-center mb-4">
          Your current credit balance is <span className="font-bold text-red-300">{balance}</span>.
        </p>
        <p className="text-white/90 text-center mb-6">
          You need to top up your credits to continue using this service.
        </p>
        <div className="flex flex-col gap-3">
          <button
            onClick={handleTopUp}
            className="w-full px-6 py-3 rounded-2xl font-semibold text-gray-900 bg-gradient-to-r from-yellow-400 to-yellow-500 hover:from-yellow-300 hover:to-yellow-400 shadow-lg transition-all"
          >
            Top Up Credits
          </button>
          {onClose && (
            <button
              onClick={onClose}
              className="w-full px-6 py-3 rounded-2xl font-semibold text-white bg-white/10 hover:bg-white/20 transition-colors border border-white/15"
            >
              Cancel
            </button>
          )}
        </div>
      </div>
    </div>
  );
}

